import { motion } from "framer-motion";

const TILES = [
  {
    label: "Fresh Daily",
    title: "Fish & Chips",
    img: "/photos/fishchips.jpg",
    span: "lg:col-span-3 lg:row-span-2",
    h: "h-[420px] lg:h-full",
  },
  {
    label: "From the Fryer",
    title: "Calamari & Prawns",
    img: "/photos/calamari.jpg",
    span: "lg:col-span-2",
    h: "h-[300px]",
  },
  {
    label: "Golden Bites",
    title: "Scallops & Sides",
    img: "/photos/scallopsbites.jpg",
    span: "lg:col-span-2",
    h: "h-[300px]",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 50, clipPath: "inset(12% 0% 0% 0%)" },
  show: (i) => ({
    opacity: 1,
    y: 0,
    clipPath: "inset(0% 0% 0% 0%)",
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

const Tile = ({ t, i }) => (
  <motion.div
    variants={reveal}
    custom={i}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    data-testid={`showcase-${t.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
    className={`group relative overflow-hidden rounded-[2px] ${t.span} ${t.h}`}
  >
    <img
      src={t.img}
      alt={t.title}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
    />
    <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,23,48,0.78) 0%, rgba(0,23,48,0.05) 55%)" }} />
    <div className="absolute bottom-0 left-0 p-7 lg:p-9">
      <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-[var(--azure)]">{t.label}</span>
      <h3 className="font-display text-3xl lg:text-4xl text-white mt-2 tracking-tight">{t.title}</h3>
    </div>
  </motion.div>
);

export const Showcase = () => (
  <section data-testid="showcase-section" className="bg-white py-20 lg:py-32">
    <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--navy)] tracking-tight leading-none">
          Something for <span className="italic text-[var(--azure)]">everyone.</span>
        </h2>
        <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-[var(--slate)] max-w-xs">
          From a quick feed to feeding the whole family.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 lg:grid-rows-2 gap-5 lg:gap-6 lg:h-[640px]">
        {TILES.map((t, i) => (
          <Tile key={t.title} t={t} i={i} />
        ))}
      </div>
    </div>
  </section>
);
